module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "patrimonial-form"
  }, [_c('form', {
    staticClass: "form-ui landscape-patrimonial-ui",
    attrs: {
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "top"
  }, [(_vm.isAnonymous && !_vm.showAnonymousCtaModal) ? _c('p', {
    staticClass: "msg-success"
  }, [_c('span', {
    staticClass: "icon-check"
  }), _vm._v(" Bravo ! vous venez de finaliser votre paysage patrimonial, vous pouvez maintenant le télécharger.\n        ")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.isAnonymous || !_vm.showAnonymousCtaModal) ? [_c('div', {
    staticClass: "label solo bold"
  }, [_vm._v("\n            Je confirme que les informations renseignées sont exactes\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "ctn-toggle row"
  }, [_c('custom-toggle', {
    attrs: {
      "value": _vm.isSign
    },
    on: {
      "change": function($event) {
        _vm.isSign = $event
      }
    }
  })], 1)] : _vm._e()], 2), _vm._v(" "), (_vm.isAdvisor) ? _c('div', {
    staticClass: "bottom"
  }, [_vm._v("\n        En cliquant sur \"Demande de signature électronique\" un e-mail sera envoyé au client lui permettant de signer électroniquement le paysage patrimonial que vous avez completé\n      ")]) : _vm._e(), _vm._v(" "), (!_vm.isAdvisor && !_vm.isAnonymous) ? _c('div', {
    staticClass: "bottom"
  }, [_vm._v("\n        En cliquant sur “Signer” vous allez être redirigé vers notre module de signature électronique afin de valider la saisie de votre paysage patrimonial.\n      ")]) : _vm._e(), _vm._v(" "), (_vm.isAnonymous && _vm.showAnonymousCtaModal) ? _c('div', {
    staticClass: "column text-center"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "subtitle text-center"
  }, [_vm._v("\n          Ainsi que d'un essai gratuit d'un mois\n        ")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-red",
    attrs: {
      "to": {
        name: 'AnonymousUpgrade'
      }
    }
  }, [_vm._v("\n          Compléter mon inscription "), _c('i', {
    staticClass: "icon-arrow-full-right"
  })])], 1) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "bounce"
    }
  }, [(_vm.signaturePopupBlocked) ? _c('div', {
    staticClass: "alert alert-warning",
    attrs: {
      "role": "alert"
    }
  }, [_c('div', {
    staticClass: "alert-wrapper row"
  }, [_c('span', {
    staticClass: "icon icon-alert"
  }), _vm._v(" "), _c('div', {
    staticClass: "alert-content column"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t\t\t\tVotre navigateur a pu bloquer la fenêtre d’accès à la signature.\n\t\t\t\t\t\t\t\t"), _c('br'), _vm._v("\n\t\t\t\t\t\t\t\tC'est courant, cliquez sur le bouton à droite pour accéder au service de signature.\n\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-red",
    on: {
      "click": function($event) {
        _vm.showUnlockPopupTuto = true
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tVoir les instructions\n\t\t\t\t\t\t")])])]) : _vm._e()]), _vm._v(" "), (_vm.showUnlockPopupTuto) ? _c('unlock-signature-popup-tutorial', {
    on: {
      "close": function($event) {
        _vm.showUnlockPopupTuto = false
      }
    }
  }) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "title"
  }, [_vm._v("\n          Complétez votre inscription pour bénéficier"), _c('br'), _vm._v("\n          de toutes les fonctionnalités Patrimoffice\n        ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47677220"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/MyPatrimonialLandscape/Signature.vue
// module id = 1117
// module chunks = 0